import './Card.less';
import * as React from 'react';
import classnames from 'classnames';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  prefixCls?: string;
  titleNode?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  loading?: boolean;
}

const Card: React.SFC<CardProps> = (props) => {
  const { prefixCls = 'mpc', titleNode, children, className, loading } = props;
  const classes = classnames({
    [`${prefixCls}-card`]: true,
    [`${prefixCls}-card-loading`]: loading,
  }, className);
  const titleClasses = classnames({ [`${prefixCls}-card-title`]: true });
  const bodyClasses = classnames({ [`${prefixCls}-card-content`]: true });
  const loadingClasses = classnames({ [`${prefixCls}-card-loading-bg`]: true });

  return (
    <div className={classes}>
      {titleNode !== undefined && <div className={titleClasses}>{titleNode}</div>}
      <div className={bodyClasses}>
        {
          loading ? (
            <div className={loadingClasses} />
          ) : children
        }
      </div>
    </div>
  );
};

export default Card;
